import { useState } from "react";
import { cutScenes } from "@/mocks/lustCaution";

export default function CutScenes() {
  const tags = ["全部", ...Array.from(new Set(cutScenes.map((s) => s.tag)))];
  const [filter, setFilter] = useState("全部");

  const list = filter === "全部" ? cutScenes : cutScenes.filter((s) => s.tag === filter);

  return (
    <section id="cuts" className="w-full bg-background-50 scroll-mt-20">
      <div className="px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
            <div className="max-w-2xl">
              <p className="text-primary-600 font-label text-sm tracking-widest uppercase">Cut Scenes</p>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold text-foreground-950 leading-snug">
                被删减的片段，究竟删掉了什么
              </h2>
              <p className="mt-5 text-foreground-600 leading-relaxed">
                删减不是简单地把画面拿掉，它往往连带着删去了一段心理变化的铺垫。
                下面按类型梳理这些片段在叙事里各自承担的作用，以及缺失之后会被削弱的部分。
              </p>
            </div>

            <div className="flex flex-wrap gap-2">
              {tags.map((tag) => (
                <button
                  key={tag}
                  type="button"
                  onClick={() => setFilter(tag)}
                  className={`px-4 py-2 rounded-full text-sm font-label transition-colors cursor-pointer whitespace-nowrap ${
                    filter === tag
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-100 border border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {tag}
                </button>
              ))}
            </div>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {list.map((scene, index) => (
              <article
                key={scene.title}
                className="flex flex-col rounded-lg bg-background-100 border border-background-200 p-5 md:p-6 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center justify-between">
                  <span className="px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-label">{scene.tag}</span>
                  <span className="font-heading text-3xl text-background-300 leading-none">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 leading-snug">{scene.title}</h3>
                <p className="mt-3 text-sm text-foreground-700 leading-relaxed">{scene.summary}</p>
                <div className="mt-4 pt-4 border-t border-background-300/60">
                  <p className="flex items-start gap-2 text-sm text-primary-700 leading-relaxed">
                    <i className="ri-error-warning-line mt-0.5 shrink-0" aria-hidden="true"></i>
                    <span>{scene.lost}</span>
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}